import { isBasicPollDeadlineOpen } from "../voting-deadlines";

// Pure predicate extracted from SchedulerPage.canVoteEmbeddedPoll so the
// deadline/accepted/finalized/cancelled gating is unit-testable without
// mounting the card. The wall-clock read stays at the call site (`now` is
// injected); this function never touches Date.now() itself.
//
// Mirrors the original gating: an accepted participant may vote while the
// scheduler is live and the poll is OPEN. M3a adds the deadlinePassed gate so
// voting closes automatically at the configured deadline. M3b also excludes a
// persisted CLOSED status so the votability gate stays consistent with the
// results-view-model / status-badge, which both treat CLOSED as not-open
// (today CLOSED arrives only via deadline/cancel, but guarding the persisted
// status keeps the gates from disagreeing if it is ever written).
export function isEmbeddedPollVotable({
  poll,
  isAcceptedParticipant,
  canGuestVote = false,
  schedulerCancelled,
  now = Date.now(),
}) {
  const pollStatus = poll?.status || "OPEN";
  const deadlinePassed = !isBasicPollDeadlineOpen(poll, now);
  return Boolean(
    (isAcceptedParticipant || canGuestVote) &&
      !schedulerCancelled &&
      pollStatus !== "FINALIZED" &&
      pollStatus !== "CLOSED" &&
      !deadlinePassed
  );
}
